import _isString from "lodash/isString";
import _isNil from "lodash/isNil";
export var formatShortText = function formatShortText(val, textLength) {
  if (_isNil(val) || !_isString(val) || !val.length) return '';
  var text = val.replace(/(<([^>]+)>)/gi, '');
  var textLengthVal = textLength !== null && textLength !== void 0 ? textLength : 200;
  return text.length > textLengthVal ? "".concat(text.substring(0, textLengthVal), "...") : text;
};